import { useState } from "react";
import { useEditAssignmentMarkMutation } from "../../../features/assignmentMark/assignmentMarkApi";

export default function AssignmentMark({ assignmentmark }) {
  const [editAssignmentMark, { isSuccess, isLoading, isError }] =
    useEditAssignmentMarkMutation();
  const [mark, setMark] = useState(assignmentmark.totalMark);
  const handleSubmit = (mark) => {
    editAssignmentMark({
      id: assignmentmark.id,
      data: {
        mark: Number(mark),
        status: "published",
      },
    });
  };
  if (assignmentmark?.status === "pending")
    return (
      <tr>
        <td className="table-td">{assignmentmark.title}</td>
        <td className="table-td">
          {new Date(assignmentmark.createdAt).toLocaleDateString("default", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </td>
        <td className="table-td">{assignmentmark.student_name}</td>
        <td className="table-td">{assignmentmark.repo_link}</td>
        <td className="table-td input-mark">
          <input
            max="100"
            value={mark}
            onChange={(e) => setMark(e.target.value)}
          />
          <svg
            onClick={() => handleSubmit(mark)}
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>
        </td>
      </tr>
    );
  if (assignmentmark?.status === "published")
    return (
      <tr>
        <td className="table-td">{assignmentmark.title}</td>
        <td className="table-td">
          {new Date(assignmentmark.createdAt).toLocaleDateString("default", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </td>
        <td className="table-td">{assignmentmark.student_name}</td>
        <td className="table-td">{assignmentmark.repo_link}</td>
        <td className="table-td">{assignmentmark.mark}</td>
      </tr>
    );
}
